import { Device } from '../helpers/Device'
import WebModel from '../models/WebModel'
import { Slot } from './Slot'
import { domReady } from '../helpers/DOM'
import PrebidFacade from '../prebidFacade/PrebidFacade'
import SlotRepository from './SlotRepository'
import Blocklist from '../blocklist/Blocklist'

const MOBILE_ADUNIT_ID = 'interstitial_mobile'
const DESKTOP_ADUNIT_ID = 'interstitial_desktop'
const WAIT_TIME = 6000

export class Interstitial extends Slot {
  slotName = 'interstitial'
  lazy = true
  outOfPage = true
  createdSlot

  constructor(
    public model: WebModel,
    readonly blocklist: Blocklist,
    readonly prebidFacade: PrebidFacade
  ) {
    super(Interstitial.setupInterstitialSlot(), model)
    this._sizes = this.adSizes
    this.adUnitId = Device.isMobileOrTablet
      ? MOBILE_ADUNIT_ID
      : DESKTOP_ADUNIT_ID

    const isBlocklisted = this.blocklist.isBlockListed(this)
    // Don't do anything if the pub doesn't have interstitials enabled.
    // Short circuit for Desktop until that becomes a thing
    if (
      (Device.isMobileOrTablet && !model.enable_interstitial_ads) ||
      (!Device.isMobileOrTablet && !model.enable_desktop_interstitial_ads) ||
      isBlocklisted
    ) {
      return
    }

    SlotRepository.add(this)

    domReady(() => {
      // Wait a bit for the ATF ads to load before requesting interstitial bids.
      setTimeout(() => {
        if (Interstitial.canDisplayInterstitial()) {
          this.prebidFacade.requestBids([this], this.timeout.value)
        }
      }, WAIT_TIME)
    })
  }

  static setupInterstitialSlot(): ISlotModel {
    const interstitialSlotModel: ISlotModel = {
      adUnitId: Device.isMobileOrTablet ? MOBILE_ADUNIT_ID : DESKTOP_ADUNIT_ID,
      type: 'Interstitial' as SlotClass,
      selector: '.mv-find-nothing-plz',
      insertPosition: undefined,
      refreshTime: undefined
    }

    return interstitialSlotModel
  }

  static canDisplayInterstitial(): boolean {
    // The localStorage key '__lsv__' will look like this if it has a value: "[1602099256851]"
    // The number is a timestamp for the last time an interstitial ad was shown to a user.
    // Google will only allow an auction for interstitial slots once / hour / domain / user.

    //@ts-ignore
    const timestamp = JSON.parse(localStorage.getItem('__lsv__'))

    if (timestamp) {
      const oneHourInMs = 60 * 60 * 1000
      const now = new Date().getTime()
      const lastSeen = timestamp[0]

      const diff = now - lastSeen

      return diff > oneHourInMs
    } else {
      return true
    }
  }

  private get adSizes(): AdSizes {
    const sizes: AdSizes = []

    if (Device.isMobile) {
      sizes.push([300, 250], [320, 480])
    } else if (Device.isTablet) {
      sizes.push([336, 280], [320, 480])
    } else {
      sizes.push([320, 480], [300, 250], [336, 280])
    }

    return sizes
  }
}
